define([
	'jquery',
	'pubsub',
	'shared.main.screen',
	'autocomplete.base',
	'shared.main.scroll',
	'search-autosuggest-helpers'
	], function($, pubsub, screenSize, autoComplete) {

		/**
		*
		*	Search Auto Suggest - Extends autocomplete.base.js - Extends handlebars-core.js
		*
		*/

		'use strict';

		var DEBUG = false,
			PLUGIN_IDENTIFIER = 'searchAutoSuggest';
		var tnfTopNavNewDesignEnabled = WCS_CONFIG.get('topnav::aemTopnavNewDesignEnabled') || false;
		var pdpDatalayerSuggestedSearchEventEnabled = WCS_CONFIG.get('ANALYTICS::pdpDatalayerSuggestedSearchEventEnabled') || false;
		var transparentNavToggle = false;
		
		if ( DEBUG ) console.log('searchAutoSuggest file loaded');

		var	searchAutoSuggest = function( element, options ) {

			this.pluginID = PLUGIN_IDENTIFIER;

			this.element = element;
			
			this.$element = $(this.element);

			this.$searchForm = this.$element.is('form') ? this.$element : this.$element.closest('form');

			// set defaults for both cms and wc top nav
			// TODO - remove selector for .header-search-term-input-js once migration to CMS top nav is complete for all brands
			this.$searchInput = this.$element.find('.header-search-term-input-js, .topnav-search-input');
			
			this.metadata = this.$element.data('options');

			this.$searchContainer = null;
			
			this.$resultsContainer = null;

			this.$instructions = $('#search-autocomplete-instruct');

			this.$liveregion = $('#search-autocomplete-live-text');
			this.liveregionText = this.$liveregion.data('liveText') ? this.$liveregion.data('liveText').trim() : 'results for';
			
			this.resultsDisplayed = false;

			this.options = options || {};

			this.keys = {
				down: 40,
				enter: 13,
				esc: 27,
				left: 37,
				right: 39,
				space: 32,
				tab: 9,
				up: 38
			};

			this.searchAutoSuggestInit();

		};

		searchAutoSuggest.prototype = {
		
			defaults : {
				action: 'after', // where to place the rendered template
				topnav: '.topnav-header',
				resultsId: 'search-autocomplete-results',
				resultsContainer: '.autosuggest-results-container', // template outer div
				numsuggestions : 7,
				numfeatured : 3, 
				highlightTerm : false,
				hasTopSearches : false,
				topSearchesText : 'Top Searches :',
				searchAllText : 'Search All :',
				displayKeywordsText : true, 
				quotesOnTextResults : true, 
				commaSeparated : false, 
				displayFeaturedResultsTextHeader : true,
				hasFeaturedResults: true, 
				featuredResultsText : 'Featured Results :',
				activeClass: 'autosuggest-active',
				overlayClass: 'autosuggest-overlay',
				priceDisplay: 'offer-only',
				searchTerm: '.search-term-js',
				closeBtn: '.autosuggest-overlay-close',
				promoContainer: '.topnav-promobar-innercontainer',
			},

			// additional init method for autosuggest
			searchAutoSuggestInit : function () {

				if ( DEBUG ) console.log('search autosuggest searchAutoSuggestInit');

				this.$window = $(window);
				this.$body = $('body');
				this.$topnav = $(this.defaults.topnav);

				if(this.$topnav.closest('.transperant-topnav').length) {
                    transparentNavToggle = true;
                } 

				this.searchAutoSuggestEvents();
			},

			build : function () {
				var self = this;

				if ( DEBUG ) console.log('search autosuggest build');

				// detect if the expanded template is used and adjust where the search results get added
				// beacuse of the overlay effect on small screens, the expanded view needs to be added 
				// below the topnav, but within the header
				if(self.config.template === "html.search-autosuggest.expanded") {
					self.config.expandedView = true;
					self.config.searchContainer = ".topnav";
				}

				// for small screens, enable the overlay for the expanded template
				if (screenSize.size() === "small" && self.config.expandedView) {
					self.enableResultsOverlay();
				}
				
				self.$searchContainer = $(self.config.searchContainer) || null;
				self.$searchContainer[self.config.action]('<div id="' + self.config.resultsId + '" class="' + self.config.resultsContainer.replace('.','') + ' hide"></div>');

				if ( pdpDatalayerSuggestedSearchEventEnabled ) {
					$('#'+self.config.resultsId).click(function(event){ 
						if($(event.target).parents('.autosuggest-results__featured-results-item').length > 0 || $(event.target).parents('.autosuggest-results__suggestions-list').length > 0) {
							window.localStorage.setItem('suggestedProductClicked',true);
						}
					});
				}
				
				self.searchAutoSuggestWindowResizeEventToken = $.pubsub('subscribe', 'window.resize.breakpoint', function(event, data){
					self.handleWindowResize(data);
				});

				self.$promoContainer = $(self.config.promoContainer);
			},

			enableResultsOverlay: function() {
				var self = this;
				this.$body.addClass(self.config.overlayClass);
			},
	
			disbleResultsOverlay: function() {
				var self = this;
				self.$body.removeClass(self.config.overlayClass);
			},

			positionContainer: function() {
				var self = this;

				// expanded view
				if (self.config.expandedView ) 
					// on small screens, use default css value
					if (screenSize.size() === 'small')
						self.$resultsContainer.css('top', '');
					// on medium/large screens, position below header and promobar
					else {
						if(tnfTopNavNewDesignEnabled && !transparentNavToggle)  
							self.$resultsContainer.css('top', self.$topnav.outerHeight());
						 else
							 self.$resultsContainer.css('top', self.$topnav.outerHeight() + self.$promoContainer.outerHeight());
					}
				// non-expanded view
				else
					// position below search container
					self.$resultsContainer.css('top', self.$searchContainer.innerHeight());
			},

			// overwriting core render for autocomplete - need to adjust data return
			render: function (response) {

				if ( DEBUG ) console.log('autoSuggest render');

				var self = this;
				var data = self.formatData(response);
				// adding config to data return for use in template Handlebars helpers
				data.config = self.config;

				if(!data.suggestions.length && !data.products.length) {
					self.clearDisplay();
					return;
				}

				self.$resultsContainer = self.$resultsContainer || $(self.config.resultsContainer);

				self.$resultsContainer.html( self.compiledTemplate(data) );

				self.positionContainer();

				// Unsubscribe before we subscribe to make sure we don't double subscribe
				$.pubsub('unsubscribe', self.searchAutoSuggestStickyEventToken);
				self.searchAutoSuggestStickyEventToken = $.pubsub('subscribe', 'vfdp.topnav.sticky', function(){
					self.positionContainer();
				});

				self.$resultsContainer.removeClass('hide');

				self.$searchInput.attr({
					'aria-expanded':'true'
				});

				self.resultsDisplayed = true;

				if(self.config.expandedView) {
					self.$body.addClass(self.config.activeClass);
				}

				// When the topnav is sticky and not in expanded view, set the max height on the search results to prevent the
				// results from displaying beyond the viewable area and enable scrolling within the results
				if(!this.config.expandedView && this.$topnav.hasClass('sticky')) {
					var resultsHeight = this.$window.height() - this.$resultsContainer.offset().top;

					this.$resultsContainer.css({
						'max-height': resultsHeight,
						'overflow-y': 'auto'
					});
				}

				// Update liveregion text with searched term
				self.$liveregion.html((data.products.length < self.config.numfeatured ? data.products.length : self.config.numfeatured) + ' ' + self.liveregionText + ' "' + data.term + '"');

				// Trap Focus Within Results Container
				self.trapFocus();

				self.$resultsContainer.on('keydown.search.results', self, self.searchResultsKeydownHandler);
			},

			// Trap Focus Within Results Container
			trapFocus: function() {
				var self = this,
					$closeBtn = self.$resultsContainer.find(self.defaults.closeBtn),
					$lastItem = self.$resultsContainer.find('[href]').last();

				$closeBtn.on('focusout', function(event){
					if( !$(event.relatedTarget).closest('.autosuggest-results-container').length ) {
						$lastItem.focus();
					}
				});

				$lastItem.on('focusout', function(event){
					if( !$(event.relatedTarget).closest('.autosuggest-results-container').length ) {
						$closeBtn.focus();
					}
				});
			},

			// Converts API responses from Bloomreach and WCS to a common JSON object
			formatData: function(data) {
				var self = this;
				return {
					term: data.term,
					suggestions: self.formatSuggestions(data),
					products: self.formatProducts(data)
				};
			},

			formatSuggestions: function(data) {
				// SOLR and BLOOMREACH.v1
				if(data.response && data.response.suggestions && data.response.suggestions.length) {
					return data.response.suggestions.map(function(val, index) {
						return {
							keyword: (val.keyword) ? val.keyword : ((val.dq) ? val.dq : "")
						};
					});
				}
				// BLOOMREACH.v2
				else if(data.suggestionGroups && data.suggestionGroups.length && data.suggestionGroups[0].querySuggestions && data.suggestionGroups[0].querySuggestions.length) {
					return data.suggestionGroups[0].querySuggestions.map(function(val, index) {
						return {
							keyword: val.displayText ? val.displayText : ""
						};
					});
				}
				else {
					return [];
				}
			},

			formatProducts: function(data) {
				var self = this;

				// SOLR and BLOOMREACH.v1
				if(data.response && data.response.products && data.response.products.length) {
					return data.response.products.map(function(val, index) {
						return {
							label: (val.label) ? val.label : ((val.title) ? val.title : ""),
							category: (val.category) ? val.category : "",
							price: self.formatPrice((val.sale_price) ? val.sale_price : ((val.price) ? val.price : "")), 	  // TODO (VFDP-112018): REMOVE formatPrice()!!!!!!!
							list_price: self.formatPrice((val.list_price) ? val.list_price : ((val.price) ? val.price : "")), // TODO (VFDP-112018): REMOVE formatPrice()!!!!!!!
							image: (val.image) ? val.image : (val.autosuggest_image_url ? val.autosuggest_image_url : ((val.thumb_image) ? val.thumb_image : "")),
							url: (val.autosuggest_pdp_link) ? val.autosuggest_pdp_link : (val.url ? val.url : ""),
						};
					});
				}
				// BLOOMREACH.v2
				else if(data.suggestionGroups && data.suggestionGroups.length && data.suggestionGroups[0].searchSuggestions && data.suggestionGroups[0].searchSuggestions.length) {
					return data.suggestionGroups[0].searchSuggestions.map(function(val, index) {
						return {
							label: val.title ? val.title : "",
							category: val.category ? val.category : "",
							price: self.formatPrice(val.sale_price ? val.sale_price : ""), // TODO (VFDP-112018): REMOVE formatPrice()!!!!!!!
							list_price: self.formatPrice(val.price ? val.price : ""), 	   // TODO (VFDP-112018): REMOVE formatPrice()!!!!!!!
							image: val.thumb_image ? val.thumb_image : "",
							url: val.url ? val.url : "",
						};
					});
				}
				else {
					return [];
				}
			},

			// TODO (VFDP-112018): REMOVE ME!!!!!!!
			// This is intended to format the pricing as a string when the autosuggest API returns a number
			// ie. (int)35 -> (string) CAD 35,00
			formatPrice: function(price) {
				// We only format numbers, not strings
				if(typeof price !== 'number')
					return price;

				var pageMetaLocale = $('meta[name="locale"]');
				var pageLocale = pageMetaLocale.attr('content').replace('_', '-').toLowerCase(); // Such a hack.
				var currencyCode = WCS_CONFIG.get('global::currencyCode');
				var currencyDisplay = WCS_CONFIG.get('global::currencySymbol');
				// Return the original price if we can't get the proper currency code
				if(!currencyCode || !pageLocale || !currencyDisplay)
					return price;

				// Check if this locale is supported
				var locales = Intl.NumberFormat.supportedLocalesOf(pageLocale);
				if(!locales.length)
					return price;

				var currencyOptions = {
					style: 'currency',
					currency: currencyCode,
					currencyDisplay: (currencyCode === currencyDisplay) ? 'code' : 'symbol'
				};

				return new Intl.NumberFormat(locales[0], currencyOptions).format(price);
			},

			searchAutoSuggestEvents : function () {

				if ( DEBUG ) console.log('searchAutoSuggestEvents');

				var self = this;

				// When close button is clicked, close the search results and reset the search input with focus
				$(document).on('click', self.defaults.closeBtn, function(){
					self.clearDisplay();
					self.$searchInput.val("").focus();
				});

				// need to filter out double click event coming from the detestable Scene 7
				document.addEventListener('click', function(event){
					if ( $(event.srcElement).hasClass('s7button') ){
						return false;
					}
					self.handleDocumentClick(event);
				});

				// move focus to results container when tab key or down arrow
				// is pressed from search input field
				self.$searchInput.on('keydown.search.input', function(event) {
					switch(event.keyCode) {
						case self.keys.esc:
							event.preventDefault();
							self.clearDisplay();
							self.$searchInput.val("").focus();
						break;

						case self.keys.down:
						case self.keys.tab:
							if( self.resultsDisplayed ) {
								event.preventDefault();
								self.$resultsContainer.find(self.defaults.closeBtn).focus();
							}
						break;
					}
				});
			},

			handleDocumentClick : function (event) {

				if ( DEBUG ) console.log('handleDocumentClick');

				var $target = $(event.target);

				// when not in expanded view on small screens, detect click location. Otherswise close search results
				if ((!this.config.expandedView || screenSize.size() !== "small") && ($target.closest(this.$resultsContainer).length > 0 || $target.is(this.$resultsContainer)) ) {
					return false;
				} else {
					this.clearDisplay();
				}

			},

			clearDisplay : function () {

				if ( DEBUG ) console.log('search autosuggest clearDisplay');

				var self = this;

				$(self.config.resultsContainer).off('keydown.search.results', self, self.searchResultsKeydownHandler).addClass('hide').empty();

				self.resultsDisplayed = false;

				self.$searchInput.attr({
					'aria-expanded':'false'
				});

				this.$body.removeClass(this.config.activeClass);

				$.pubsub('unsubscribe', self.searchAutoSuggestStickyEventToken);
			},

			handleWindowResize : function (data) {

				if ( DEBUG ) console.log('handleWindowResize');

				this.clearDisplay();

				if(data.now === 'small' && this.config.expandedView) {
					this.enableResultsOverlay();
				}
				else {
					this.disbleResultsOverlay();
				}
			},

			searchResultsKeydownHandler : function(event) {
				var self = event.data;

				if(event.keyCode == self.keys.esc) {
					self.clearDisplay();
					self.$searchInput.val("").focus();
				}
			}
		};

		searchAutoSuggest.defaults = searchAutoSuggest.prototype.defaults;
		
		searchAutoSuggest.prototype = $.extend(true, {}, autoComplete.prototype, searchAutoSuggest.prototype);
		
		// prevent duplicate instantiation
		$.fn.searchAutoSuggest = function(options) {
			return this.each(function() {
				var instance = $(this).data(PLUGIN_IDENTIFIER);
				if(!instance) {
					instance = new searchAutoSuggest(this, options).init();
					$(this).data(PLUGIN_IDENTIFIER,instance);
				}
			});
		};

	}
);